var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Whoops!")]),_c('p',[_vm._v("You've come to a dead end here. Click "),_c('router-link',{attrs:{"to":"/main"}},[_vm._v("here")]),_vm._v(" to go back home.")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }